import React, { useEffect, useState } from "react";
import { FunctionComponent } from "react";
import Container from "../components/Container.tsx";
import Navbar from "../components/Navbar.tsx";
import Section1 from "../components/About/Section1.tsx";
import Section2 from "../components/About/Section2.tsx";
import Section3 from "../components/About/Section3.tsx";
import Section4 from "../components/About/Section4.tsx";
import SectionConsultation from "../components/About/SectionConsultation.tsx";
import Footer from "../components/Main/Footer.tsx";
import Section5 from "../components/About/Section5.tsx";
import Section6 from "../components/About/Section6.tsx";
import Breadcrumb from "../components/Breadcrumb.tsx";
import { ConsultationEng } from "../svg_groups/consultation_eng.js";
import styles from "../components/About/css/Section3.module.css";
import NavbarMobile from "../components/NavbarMobile.tsx";
import { useSelector } from "react-redux";

const Main = () => {
  const reduxStateLanguage = useSelector((state: any) => state.language.value);

  const [isMobile, setIsMobile] = useState(window.innerWidth < 1180);

  return (
    <Container>
      {isMobile ? (
        <NavbarMobile lang={reduxStateLanguage} />
      ) : (
        <Navbar lang={reduxStateLanguage} />
      )}
      <Breadcrumb tab={"About"} />
      <Section1 />
      <Section2 />
      <Section3 />
      <SectionConsultation />
      {/* <div className={styles.consultation}>
        <svg
          id="not_ts"
          width="128"
          height="128"
          viewBox="0 0 128 128"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M69.3038 83.7574L64.5308 88.5303C64.2379 88.8232 63.763 88.8232 63.4701 88.5303L58.6972 83.7574C58.4043 83.4645 58.4043 82.9896 58.6972 82.6967C58.9901 82.4038 59.4649 82.4038 59.7578 82.6967L63.2505 86.1893L63.2505 47L64.7505 47L64.7505 86.1893L68.2431 82.6967C68.536 82.4038 69.0109 82.4038 69.3038 82.6967C69.5967 82.9896 69.5967 83.4645 69.3038 83.7574Z"
            fill="#C4B57C"
          />
        </svg>
        <ConsultationEng />
      </div>
      <Section4 />
      <Section5 />
      <Section6 /> */}
      <Footer />
    </Container>
  );
};

export default Main;
